import { render } from "./UpdatePrimaryStorage.vue?vue&type=template&id=32a9f6df&scoped=true"
import script from "./UpdatePrimaryStorage.vue?vue&type=script&lang=js"
export * from "./UpdatePrimaryStorage.vue?vue&type=script&lang=js"

import "./UpdatePrimaryStorage.vue?vue&type=style&index=0&id=32a9f6df&scoped=true&lang=less"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a9f6df"]])

export default __exports__